import { signOut } from 'helpers/cookie.helpers'
import { openErrorToaster } from 'helpers/toaster.helpers'
// import { getTranslation } from 'helpers/translations.helpers'
import store from 'index'
// import errorMessages from 'network/messages/errorMessages'
import { stopLoader } from 'redux-store/redux/slices/loader.slice'
import * as Sentry from '@sentry/react'

const EXCLUDE_ERROR_TOASTER_FOR_ERROR_CODE = [3038]

export const errorHandler = (error) => {
  // Configure Sentry context for Axios errors
  if (error && error.config) {
    const requestUrl = error.config.url
    const requestMethod = error.config.method?.toUpperCase()
    const statusCode = error.response?.status
    const errorCode = error?.response?.data?.errors?.[0]?.errorCode

    // Set tags for better filtering and grouping
    if (requestUrl) Sentry.setTag('request_url', requestUrl)
    if (requestMethod) Sentry.setTag('request_method', requestMethod)
    if (statusCode) Sentry.setTag('status_code', statusCode)
    if (errorCode) Sentry.setTag('error_code', errorCode)
    Sentry.setTag('error_type', 'axios_error')

    // Set context for additional debugging information
    Sentry.setContext('axios_request', {
      url: requestUrl,
      method: requestMethod,
      headers: error.config.headers,
      data: error.config.data,
      params: error.config.params
    })

    Sentry.setContext('axios_response', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data ? JSON.stringify(error.response.data) : undefined,
      headers: error.response?.headers ? JSON.stringify(error.response.headers) : undefined
    })

    // Create a custom fingerprint based on URL and status code for better grouping
    const fingerprint = `axios_${requestMethod}_${requestUrl}_${statusCode}`
    if (Sentry.getCurrentScope) {
      Sentry.getCurrentScope().setFingerprint([fingerprint])
      Sentry.getCurrentScope().setTransactionName(fingerprint)
    }

    error.name = `AXIOS Error: ${requestMethod} request on ${requestUrl} statusCode: ${statusCode}`
  }

  Sentry.captureException(error)

  // Defensive: check for error.response and error.response.config before accessing
  if (error && error.response && error.response.status === 500) {
    if (error.response.config && error.response.config.loader) {
      store.dispatch(stopLoader(error.response.config.loader))
    }
    return Promise.reject(error.response.data?.errors)
  } else if (error && error.response && error.response.status === 401) {
    // Snackbar UnAuthed
    const errorCode = error?.response?.data?.errors?.[0]?.errorCode
    if (errorCode === 3036) { // session changed
      window.history.pushState({ errorMsg: 'sessionExpired', errorCause: 'newLoginDetected', replace: true }, '', `${window.origin}/error`)
      window.location.reload()
    }
    if (errorCode === 3035) { // session changed
      window.history.pushState({ errorMsg: 'sessionExpired', errorCause: 'invalidToken', replace: true }, '', `${window.origin}/error`)
      window.location.reload()
    }
    signOut()
    if (error.response.config && error.response.config.loader) {
      store.dispatch(stopLoader(error.response.config.loader))
    }
    return Promise.reject(error.response.data?.errors)
  } else if (error && error.response && error.response.config && error.response.config.loader) {
    // Other errors
    store.dispatch(stopLoader(error.response.config.loader))
  }

  // Open Error Toaster
  if (
    error &&
    error.response &&
    error.response.config &&
    error.response.config.errorHandlerEnabled &&
    !EXCLUDE_ERROR_TOASTER_FOR_ERROR_CODE.includes(error?.response?.data?.errors?.[0]?.errorCode)
  ) {
    const errorMessage = error?.response?.data?.errors?.[0]?.description
    openErrorToaster({ message: errorMessage })
  }

  // Defensive: if error.response or error.response.data is missing, just reject the error
  return Promise.reject(error.response?.data?.errors || error)
}
